export const getLocalizedImagePathConverter = (
  image: {
    imageSrc: string
    imageSrcSet?: string
  },
  language: string,
  languagePattern = /\{\{language\}\}/g
): { src: string; srcSet: string | undefined } => {
  const localizedSrc = image.imageSrc.replace(languagePattern, language)
  const localizedSrcSet = image.imageSrcSet
    ? image.imageSrcSet.replace(languagePattern, language)
    : undefined
  return {
    src: localizedSrc,
    srcSet: localizedSrcSet,
  }
}
